import React, { useState } from 'react';
import EventsAdmin from './EventsAdmin';
import DocumentsAdmin from './DocumentsAdmin';
import PostcodesAdmin from './PostcodesAdmin';
import NewsAdmin from './NewsAdmin';
import CommitteeAdmin from './CommitteeAdmin';
import './Admin.css';

const TABS = [
  { id: 'events',    label: 'Events' },
  { id: 'news',      label: 'News' },
  { id: 'documents', label: 'Documents' },
  { id: 'committee', label: 'Committee' },
  { id: 'postcodes', label: 'Postcodes' },
];

export default function Admin() {
  const [tab, setTab] = useState('events');

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <h2 className="admin-title">Admin</h2>
        <nav>
          {TABS.map(({ id, label }) => (
            <button
              key={id}
              className={`admin-tab-btn ${tab === id ? 'active' : ''}`}
              onClick={() => setTab(id)}
            >
              {label}
            </button>
          ))}
        </nav>
        <a href="/.auth/logout?post_logout_redirect_uri=/" className="admin-logout">
          Sign out
        </a>
      </aside>

      <main className="admin-main">
        {tab === 'events'    && <EventsAdmin />}
        {tab === 'news'      && <NewsAdmin />}
        {tab === 'documents' && <DocumentsAdmin />}
        {tab === 'committee' && <CommitteeAdmin />}
        {tab === 'postcodes' && <PostcodesAdmin />}
      </main>
    </div>
  );
}
